import {CustomRouteSuggestion} from "@/components/RoutePlanner/ValueObjects/CustomRouteSuggestion";

export default class DefaultState{
  loading = false;
  customRouteSuggestions: CustomRouteSuggestion[] = [];
  suggestionTimeout: number|null = null;
}
